import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import { AxiosError } from "axios";
import Button from "components/button";
import Clock from "components/icon/clock";
import OtpInput from "components/otp-input";
import { LoaderContext } from "contexts/loader-context";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useCountdown } from "rooks";
import formServices from "services/form-builder-services";
import ProfileService from "services/profile-services";
import { TextOtp } from "../text.style";
import { Div, PTime } from "./styled.component";

function Otp({ state, helper, handleChange, onFormSubmitEndPoint, prevStep, setHelper, session, recaptchaRef, setError }: any) {

  const { handleSubmit, formState: { errors }, setValue } = useForm({ resolver: yupResolver(formServices.formGenerateSchema(["otp"])) })
  const [endTime, setEndtime] = useState(new Date(helper.expires))
  const { setLoad } = useContext(LoaderContext)
  const [endTimeTransform, setEndTimeTransform] = useState<string | null>(null)
  const count = useCountdown(endTime, { interval: 1000 })

  const secondsToString = (seconds: number) => {
    let minute: any = Math.floor((seconds / 60) % 60)
    minute = minute < 10 ? '0' + minute : minute
    let second: any = seconds % 60
    second = second < 10 ? '0' + second : second
    return minute + ':' + second
  }

  useEffect(() => {
    setEndtime(new Date(helper.expires))
  }, [helper.expires])

  useEffect(() => {
    if (count > 0) {
      setEndTimeTransform(secondsToString(count))
    } else if (count === 0) {
      setEndTimeTransform(null)
      setError(71)
    }
  }, [count])

  const otpGenerate = async () => {
    recaptchaRef.current?.reset()
    await recaptchaRef.current?.executeAsync().then(async (recaptchaToken: any) => {
      setLoad(true)
      try {
        const result = await ProfileService.otpGenerate({ phone: state.phoneNumber, recaptchaToken, session })
        if (result.status === 201) {
          setHelper({ expires: result.data?.expiresAt })
        }
      } catch (err) {
        const typedError = err as AxiosError
        const { code } = typedError.response?.data || {}
        setError(code)
      } finally {
        setLoad(false)
      }
    })
  }

  function onFormSubmit(data: any) {
    handleChange(data)
    onFormSubmitEndPoint(data)
  }

  return (
    <Div className="flex flex-col flex-1 md:pt-10">
      <form className="flex h-full justify-between flex-col gap-4 mx-7 mb-7" onSubmit={handleSubmit(onFormSubmit)} noValidate>
        <p className="text-center text-lg font-medium saira uppercase">Ingresa el código de 6 dígitos QUE RECIBISTE para verificar tu CELULAR.</p>
        <div className="flex-1 flex flex-col gap-4">
          <div className="gap-2 flex flex-col">
            <OtpInput setValue={setValue} />
            <ErrorMessage errors={errors} name="otp" />
          </div>
          <div className="flex-1 flex justify-center">
            <div className="h-full flex flex-col justify-center items-center text-center w-4/5">
              <PTime className="flex gap-2">
                <Clock />
                {endTimeTransform}
              </PTime>
              <TextOtp className="my-4">Una contraseña de un solo uso se envió al {state.phoneNumber}</TextOtp>
              <TextOtp className="flex flex-col items-center">
                <b>¿No la recibió?</b>
                <span
                  className="underline cursor-pointer ml-2"
                  onClick={() => {
                    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'MODIFICAR TELEFONO - Reenviar código OTP', value: '10' })
                    otpGenerate()
                  }}
                >
                  reenviar código
                </span>
              </TextOtp>
            </div>
          </div>

        </div>
        <Button>
          <p className="uppercase">Verificar</p>
        </Button>
        <button type="button" className="cursor-pointer" onClick={() => {
          gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'MODIFICAR TELEFONO - Volver atras', value: '10' })
          prevStep()
        }}>
          <p
            className={`din text-center mt-3 hover:text-red-100 uppercase underline`}
            style={{ fontSize: 10 }}
          >
            VOLVER
          </p>
        </button>
      </form>
    </Div>
  )
}

export default Otp;